import definePrimitive from '../util/definePrimitive'

const Root = definePrimitive({
  name: 'Details',
  element: 'dl',
  className: 'typo-body'
})

const Name = definePrimitive({
  name: 'DetailsName',
  element: 'dt',
  className: 'mt-5 first-of-type:mt-0 mb-1 text-gray-600 typo-body'
})

const Description = definePrimitive({
  name: 'DetailsDescription',
  element: 'dd',
  className: 'text-black typo-body'
})

export {
  Root,
  Name,
  Description
}
